<app-header [label]="page_name | plural"></app-header>
<div class="bg-white py-4  rounded-t-lg">
  <!-- Toolbar -->
  <div class="flex items-center justify-between gap-4 mb-4 px-4">
    <div class="flex items-center w-full gap-4">
      <app-select-input label="University" class="w-full" [(ngModel)]="filter_university_id" [options]="is_super_admin ? dds.dropdown_list?.assessment_university_list : (dds.dropdown_list?.assessment_university_list | filterByKeyAndValue : 'id' : gs.user_data?.university_id)" (ngModelChange)="on_university_filter_change($event)"></app-select-input>
      <app-select-input label="Academic Year" class="w-full" [(ngModel)]="filter_academic_year_id" [options]="filtered_academic_years" (ngModelChange)="on_academic_year_filter_change()"></app-select-input>
      <app-select-input label="Exam Name" class="w-full" [(ngModel)]="filter_exam_id" [options]="filtered_exams" (ngModelChange)="on_exam_filter_change()"></app-select-input>
      <app-select-input label="Subject Name" class="w-full" [(ngModel)]="filter_subject_id" [options]="filtered_subjects" (ngModelChange)="on_filter_change()"></app-select-input>
    </div>

    <div class="flex gap-4 items-center w-auto">
      <app-search-input class="w-auto" #searchbar (valueChange)="on_search($event)"></app-search-input>
      <app-button color="bg-white border-primary text-primary" icon="bx bx-download" (click)="download_scripts()"></app-button>
      <app-button *ngIf="gs.user_role_data?.script_management_scripts_add" (click)="route.navigate(['/add-script/form'])" icon="bx bx-plus" color="bg-secondary text-[#310000]" [label]="page_name"></app-button>
    </div>
  </div>

  <!-- Table -->
  <div class="bg-white grid grid-rows-[1fr_auto] h-[calc(100vh-100px)] min-h-[500px]">
    <div class="overflow-auto">
      <table class="w-full">
        <!-- Header -->
        <thead *ngIf="items?.data?.length">
          <tr class="border-b border-gray-200">
            <th class="px-4 py-4">
              <input type="checkbox" class="w-4 h-4 accent-primary cursor-pointer block" [checked]="items?.data?.length && selected_rows.size === items?.data?.length" (change)="toggle_all($event)" />
            </th>
            <th class="text-left px-4 py-4 text-sm font-semibold text-primary">Scanned Date</th>
            <th class="text-left px-4 py-4 text-sm font-semibold text-primary">Total Pages</th>
            <th class="text-left px-4 py-4 text-sm font-semibold text-primary">Barcode</th>
            <th *ngIf="items?.data[0]?.Assessment?.ai_evaluation == 'enable'" class="text-left px-4 py-4 text-sm font-semibold text-primary">AI Status</th>
            <th *ngFor="let ev of evaluator_columns; let i = index" class="text-left px-4 py-4 text-sm font-semibold text-primary">Evaluator {{ i + 1 }}</th>
            <th *ngIf="head_evaluator_columns.length" class="text-left px-4 py-4 text-sm font-semibold text-primary">Head Evaluator</th>
            <th class="text-center px-4 py-4 text-sm font-semibold text-primary">Evaluation Status</th>
            <th class="text-center px-4 py-4 text-sm font-semibold text-primary"></th>
          </tr>
        </thead>
        <!-- Rows -->
        <tbody>
          <tr *ngFor="let item of items?.data" class="border-b border-gray-100 hover:bg-gray-50 transition-colors" [class.bg-blue-50]="selected_rows.has(item.id)">
            <td class="px-4 py-4">
              <input type="checkbox" class="w-4 h-4 accent-primary cursor-pointer" [checked]="selected_rows.has(item.id)" (change)="toggle_row(item.id)" />
            </td>
            <td class="px-4 py-4 text-sm text-gray-700">{{ item.document_uploaded_date || '-' }}</td>
            <td class="px-4 py-4 text-sm text-gray-700">{{ item.ScriptImages?.length ?? item.no_of_pages_per_script ?? '-' }}</td>
            <td class="px-4 py-4 text-sm text-gray-700">{{ item.barcode || '-' }}</td>
            <td *ngIf="items?.data[0]?.Assessment?.ai_evaluation == 'enable'" class="px-4 py-4 text-sm font-medium" [style.color]="item.ai_status === 'Completed' ? '#008A2E' : item.ai_status === 'Processing' ? '#D17E3F' : item.ai_status === 'Failed' ? '#DC2626' : '#9CA3AF'">
              {{ item.ai_status || '-' }}
            </td>
            <td *ngFor="let ev of evaluator_columns; let i = index" class="px-4 py-4 text-sm text-gray-700">{{ item['evaluator_' + (i + 1)]?.name || '-' }}</td>
            <td *ngIf="head_evaluator_columns.length" class="px-4 py-4 text-sm text-gray-700">{{ item.head_evaluator?.name || '-' }}</td>
            <td class="px-4 py-4 text-center">
              <ng-container *ngIf="item.is_exception_raised; else notException">
                <span class="inline-flex text-center items-center rounded-full text-sm font-medium" style="background-color:#FEE2E2; color:#991B1B; padding:8px 16px; gap:8px; height:44px; white-space:nowrap;">
                  <i class="bx bx-alert-octagon text-lg flex-shrink-0 mt-1"></i> Exception Raised
                </span>
              </ng-container>
              <ng-template #notException>
                <!-- AI Only assessments have no evaluator level, so Evaluations is always empty —
                     their status comes straight from the AI job (script.status) -->
                <ng-container *ngIf="is_ai_only_script(item); else humanEvaluated">
                  <ng-container *ngIf="item.status === 'Completed'; else aiPendingBadge">
                    <span class="inline-flex items-center rounded-full text-sm font-medium w-36" style="background-color:#DCFCE7; color:#008A2E; padding:8px 16px; gap:12px; height:44px; white-space:nowrap;">
                      <span class="w-2 h-2 rounded-full flex-shrink-0" style="background-color:#008A2E;"></span> AI Evaluated
                    </span>
                  </ng-container>
                  <ng-template #aiPendingBadge>
                    <span class="inline-flex items-center rounded-full text-sm font-medium w-36" style="background-color:#F8ECE2; color:#D17E3F; padding:8px 16px; gap:24px; height:44px;">
                      <span class="w-2 h-2 rounded-full flex-shrink-0" style="background-color:#D17E3F;"></span> Pending
                    </span>
                  </ng-template>
                </ng-container>
                <ng-template #humanEvaluated>
                <ng-container *ngIf="is_last_level_completed(item); else pendingBadge">
                  <span class="inline-flex items-center rounded-full text-sm font-medium w-36" style="background-color:#DCFCE7; color:#008A2E; padding:8px 16px; gap:24px; height:44px;">
                    <span class="w-2 h-2 rounded-full flex-shrink-0" style="background-color:#008A2E;"></span> Completed
                  </span>
                </ng-container>
                <ng-template #pendingBadge>
                  <span class="inline-flex items-center rounded-full text-sm font-medium w-36" style="background-color:#F8ECE2; color:#D17E3F; padding:8px 16px; gap:24px; height:44px;">
                    <span class="w-2 h-2 rounded-full flex-shrink-0" style="background-color:#D17E3F;"></span> Pending
                  </span>
                </ng-template>
                </ng-template>
              </ng-template>
            </td>
            <td class="px-4 py-4">
              <div class="relative flex justify-center">
                <button type="button" (click)="toggle_menu(item.id, $event)" class="p-2 rounded-lg hover:bg-gray-100 text-gray-500">
                  <i class="bx bx-dots-vertical-rounded text-xl"></i>
                </button>
                <div *ngIf="active_menu_id === item.id" class="absolute right-6 top-8 bg-white border border-gray-200 rounded-lg shadow-lg z-20 min-w-[150px]">
                  <button *ngIf="gs.user_role_data?.script_management_scripts_view" type="button" (click)="open_view_modal(item); active_menu_id = null" class="w-full flex items-center gap-2 px-4 py-2.5 text-sm hover:bg-gray-50 text-gray-700">
                    <i class="bx bx-show text-primary text-lg"></i> View Script
                  </button>
                  <button *ngIf="(item.is_exception_raised || !item['evaluator_1']?.name) && gs.user_role_data?.script_management_scripts_delete" type="button" (click)="open_delete_modal(item, null); active_menu_id = null" class="w-full flex items-center gap-2 px-4 py-2.5 text-sm hover:bg-gray-50 text-red-500">
                    <i class="bx bx-trash text-lg"></i> Delete
                  </button>
                </div>
              </div>
            </td>
          </tr>
          <!-- Empty state -->
          <tr *ngIf="!items?.data?.length">
            <td [attr.colspan]="4 + (items?.is_ai_only ? 1 : 0) + evaluator_columns.length + (head_evaluator_columns.length ? 1 : 0) + 2" class="h-[calc(100vh-350px)]">
              <div class="flex flex-col items-center justify-center h-full gap-2">
                <span class="text-2xl font-medium text-gray-800">No Data Available</span>
                <span class="text-base text-gray-400">Please select the dropdown options to view the scripts.</span>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <!-- Pagination -->
    <div class="flex justify-end items-center gap-6 px-6 py-3 bg-white border-t border-gray-200">
      <app-button *ngIf="selected_rows.size > 0" icon="bx bx-trash" (click)="open_bulk_delete_modal()"></app-button>
      <div class="flex items-center gap-3 text-sm text-[#333333]">
        <span>Rows per page</span>
        <div class="relative">
          <select [(ngModel)]="pagination.page_size" (ngModelChange)="change_page_size()" class="appearance-none text-primary text-sm font-semibold bg-transparent border-b-2 border-primary focus:outline-none cursor-pointer pr-5 pb-1">
            <option [value]="5">5</option>
            <option [value]="10">10</option>
            <option [value]="20">20</option>
            <option [value]="30">30</option>
            <option [value]="50">50</option>
          </select>
          <div class="absolute inset-y-0 right-0 flex items-center pointer-events-none">
            <i class="bx bx-chevron-down text-primary text-base"></i>
          </div>
        </div>
      </div>
      <span class="text-sm text-[#333333]">{{showingFrom}}-{{showingTo}} of {{items?.count || 0}}</span>
      <div class="flex items-center gap-1">
        <button (click)="change_pagination('previous')" [disabled]="pagination.page === 1" class="w-8 h-8 flex items-center justify-center rounded hover:bg-gray-100 disabled:opacity-40 disabled:cursor-not-allowed transition-colors">
          <i class="bx bx-chevron-left text-xl text-[#555]"></i>
        </button>
        <button (click)="change_pagination('next')" [disabled]="pagination.page === total_pages || !items?.data?.length" class="w-8 h-8 flex items-center justify-center rounded hover:bg-gray-100 disabled:opacity-40 disabled:cursor-not-allowed transition-colors">
          <i class="bx bx-chevron-right text-xl text-[#555]"></i>
        </button>
      </div>
    </div>

  </div>
</div>

<app-confirmation-popup #confirmation_disabled_modal [warning]="true" [enable_icon]="true" confirmColor="bg-[#FA2912] text-[#FFFFFF]" [is_mandatory]="true" [show_cancel_icon]="true" (confirm_modal_clicked)="delete()" (close_modal_clicked)="confirmation_delete_modal.close()">
  You cannot Disabled this record as it is already linked to other masters.
</app-confirmation-popup>
<app-confirmation-popup #confirmation_delete_modal [delete_icon]="true" confirmColor="bg-[#FA2912] text-[#FFFFFF]" [is_mandatory]="true" [show_cancel_icon]="true" (confirm_modal_clicked)="delete()" (close_modal_clicked)="confirmation_delete_modal.close()">
  Are you sure you want to Delete {{ selected_rows.size > 0 ? selected_rows.size + ' record(s)' : 'this record' }}?
</app-confirmation-popup>

<app-modal #bulk_modal label="Bulk Upload {{page_name | plural}}" sub_label="Add {{ page_name }} in Bulk">
  <app-bulk-upload [cancel]="bulk_modal" [accepted_type]="['.csv']" [title]="page_name" [accepted_type]="'.csv'" [max_file_sizeMB]="5" [bulk_columns]="bulk_columns" (submit)="bulk_upload($event.data,$event.spinner)"></app-bulk-upload>
</app-modal>

<app-modal #view_modal [label]="'View '+ page_name" width="md" (close_modal_clicked)="view_modal.close()">
  <div class="h-full overflow-auto">
    <div *ngFor="let item of script_images; let i = index" class="relative w-full mb-4">
      <img [src]="item" alt="Answer Script Image" class="w-full object-contain" />
      <!-- Blur overlay for script pages -->
      <div *ngIf="i < supplement_start_index && script_page_blur[i] > 0" class="absolute top-0 left-0 w-full backdrop-blur-[50px] pointer-events-none" [style.height.%]="script_page_blur[i]"></div>
      <!-- Blur overlay for supplement pages -->
      <div *ngIf="i >= supplement_start_index && supplement_page_blur[i - supplement_start_index] > 0" class="absolute top-0 left-0 w-full backdrop-blur-[50px] pointer-events-none" [style.height.%]="supplement_page_blur[i - supplement_start_index]"></div>
    </div>
  </div>
</app-modal>